module.exports = __webpack_public_path__ + "img/saba_maatafa_yes.823ad2b7.png";